// extracted by mini-css-extract-plugin
module.exports =  {"body":"GroupNote-ZpJO__body","header":"GroupNote-S_Gh__header"};